import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import {Grid, Box, Button} from '@material-ui/core';
import {Select, MenuItem, InputLabel, FormControl, FormControlLabel, Checkbox, Stack } from '@mui/material';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import InputAdornment from '@mui/material/InputAdornment';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import UserSelect from '../agents/AgentSelect';
///import moment from 'moment';
import axios from 'axios';
import Alert from '../components/Alert';
import {getVisibility} from '../commonfun/common';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});



const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  const childRefAlert = React.useRef(); 
  const childRefUser = React.useRef(); 
  ///const childRefTechnician = React.useRef();
  
  const [loadingBtn, setLoadingBtn] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");
  
  const [accessType, setAccessType] = React.useState(1);
  const [accessWithType, setAccessWithType] = React.useState("");
  const [accessWithNames, setAccessWithNames] = React.useState("");
  const [accessWithIds, setAccessWithIds] = React.useState("");

  const [activityTypeList, setActivityTypeList] = React.useState([]);
  const [activityParentType, setActivityParentType] = React.useState("Task");
  const [startDateTimeLabel, setStartDateTimeLabel] = React.useState("Due Date/Time");
  
  const [activityType, setActivityType] = React.useState("Call");
  const [subject, setSubject] = React.useState("");
  const [remarks, setRemarks] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [priority, setPriority] = React.useState("Normal");
  const [status, setStatus] = React.useState("Open");
  const [cancelReason, setCancelReason] = React.useState("");
  const [ownerAlias, setOwnerAlias] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);

  const [fullDay, setFullDay] = React.useState(false);
  const [showMeAs, setShowMeAs] = React.useState(false);
  const [reminderTrigger, setReminderTrigger] = React.useState(false);

  const [startDateTime, setStartDateTime] = React.useState(new Date());
  const [endDateTime, setEndDateTime] = React.useState(new Date());
  const [reminderDateTime, setReminderDateTime] = React.useState(new Date());

  // const [contentUrl, setContentUrl] = React.useState("");
  // const [contentFilePath, setContentFilePath] = React.useState("");
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function dateFormat(datetime){
    if(datetime && datetime!=null){
      let datetimeArr = datetime.split(" ");
      let dtArr = datetimeArr[0].split("-");
      let tmArr = datetimeArr[1].split(":");
      datetime = dtArr[1]+"-"+dtArr[0]+"-"+dtArr[2]+" "+tmArr[0]+":"+tmArr[1]+":"+tmArr[2];
    }
    return datetime;
  }

  React.useEffect(() => {	

    if(open && props.userObj){
      getApiDatAactivityType();
    }

    if(props.dataObj!=null && props.dataObj.autoId){  
      setActivityType(props.dataObj.activityType);
      handleActivityType(props.dataObj.activityType);
      setSubject(props.dataObj.subject);
      setRemarks(props.dataObj.remarks);
      setLocation(props.dataObj.location);
      setPriority(props.dataObj.priority);
      setStatus(props.dataObj.status);
      setCancelReason(props.dataObj.cancelReason);
      setOwnerAlias(props.dataObj.ownerAlias);
      setOwnerId(props.dataObj.ownerId);

      if(props.dataObj.fullDay===1){
        setFullDay(true);
      }else{
        setFullDay(false);
      }
      if(props.dataObj.showMeAs===1){
        setShowMeAs(true);
      }else{
        setShowMeAs(false);
      }
      if(props.dataObj.reminderTrigger===1){
        setReminderTrigger(true);
      }else{
        setReminderTrigger(false);
      }

      if(props.dataObj.startDateTime!=null){
        setStartDateTime(new Date(dateFormat(props.dataObj.startDateTime)));
      }
      if(props.dataObj.endDateTime!=null){
        setEndDateTime(new Date(dateFormat(props.dataObj.endDateTime)));
      }
      if(props.dataObj.reminderDateTime!=null){
        setReminderDateTime(new Date(dateFormat(props.dataObj.reminderDateTime)));
      }

      setAccessType(props.dataObj.accessType);
      setAccessWithType(props.dataObj.accessWithType);
      setAccessWithNames(props.dataObj.accessWithNames);
      setAccessWithIds(props.dataObj.accessWithIds);

    }else{
      
      if(activityTypeList && activityTypeList[0]){
        setActivityType(activityTypeList[0].activityType);
      }else{
        setActivityType("Call");
      }

      if(activityTypeList && activityTypeList[0]){
        setSubject(activityTypeList[0].activityType);
      }else{
        setSubject("");
      }

      setRemarks("");
      setLocation("");
      setPriority("Normal");
      setStatus("Open");
      setCancelReason("");
      if(props.userObj && props.userObj.fullName){
        setOwnerAlias(props.userObj.fullName);
        setOwnerId(props.userObj.userId);
      }else{
        setOwnerAlias("");
        setOwnerId(0);
      }

      setFullDay(false);
      setShowMeAs(false);
      setReminderTrigger(false);
    
      setEndDateTime(new Date());
      setStartDateTime(new Date());
      setReminderDateTime(new Date());

      setAccessWithType("");
      setAccessWithNames("");
      setAccessWithIds("");      
      if(open){
        setAccessType(getVisibility(props.userObj.visibilityJson,'Activities'));
      }
      
    }

	}, [props.userObj,props.dataObj,open]);

  
  async function getApiDatAactivityType(){ 
    let apiUrl=API_URL+'/crm-cache-activity-type';
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setActivityTypeList(response.data.list);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setActivityTypeList([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      }
    })
  }


	function saveData(){ 
    if(!activityType){
      setSeverityAlert("error");
      setAlertMessage("Select activity type");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }

    if(!subject){
      setSeverityAlert("error");
      setAlertMessage("Enter subject");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }

    if(!ownerAlias){
      setSeverityAlert("error");
      setAlertMessage("Select assignee");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }

		if(subject){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      } 
      data.append('relatedTo', props.relatedTo);
      data.append('relatedToId', props.relatedToId);
      data.append('relatedTitle', props.relatedTitle);
      
      if(props.relatedTo==='Account' && props.relatedToId && props.relatedToId>0){
        data.append('accountId', props.relatedToId);
      }else if(props.accountId && props.accountId>0){
        data.append('accountId', props.accountId);
      }

      data.append('activityType', activityType);
      data.append('parentActivityType', activityParentType);
      data.append('subject', subject);
      data.append('remarks', remarks);
      data.append('priority', priority);
      data.append('status', status);

      if(status==='Cancelled'){
        data.append('cancelReason', cancelReason);
      }else{
        data.append('cancelReason', '');
      }

      data.append('ownerId', ownerId);
      data.append('ownerAlias', ownerAlias);

      if(fullDay){
        data.append('fullDay', 1);
      }else{
        data.append('fullDay', 0);
      }
      if(reminderTrigger){
        data.append('reminderTrigger', 1);
        data.append('reminderDateTime', dayjs(reminderDateTime).format('YYYY-MM-DD HH:mm:ss'));
      }else{
        data.append('reminderTrigger', 0);
        data.append('reminderDateTime', '');
      }

      data.append('startDateTime', dayjs(startDateTime).format('YYYY-MM-DD HH:mm:ss'));

      if(activityParentType==='Event'){
        data.append('endDateTime', dayjs(endDateTime).format('YYYY-MM-DD HH:mm:ss'));
        data.append('location', location);
        if(showMeAs){
          data.append('showMeAs', "Busy");
        }else{
          data.append('showMeAs', "Available");
        }
      }else{
        data.append('endDateTime', '');
        data.append('location', '');
        data.append('showMeAs', '');
      }
 
      data.append('accessType', accessType);
      data.append('accessWithType', accessWithType);
      data.append('accessWithNames', accessWithNames);
      data.append('accessWithIds', accessWithIds);

      // var myContentFile = document.querySelector('#contentfile');
      //   data.append("contentFile", myContentFile.files[0]);

      let apiURL='/crm-create-activity';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-activity';
      }
      
      setLoadingBtn(true);
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setLoadingBtn(false);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);					
					setAlertMessage("Activity has been saved.");
          childRefAlert.current.handleClickOpen();
          props.updatedList(response.data.list);
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';

				}else{
          setSeverityAlert("error");					
					setAlertMessage("Activity could not be saved.");	
          childRefAlert.current.handleClickOpen();			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setAlertMessage(""+error);			
          childRefAlert.current.handleClickOpen();	
					return false;
			})	
		}		
	}

  function handleActivityType(val){
    setActivityType(val);
    setSubject(val);
    if(activityTypeList){
      for(let i=0; i<activityTypeList.length; i++){
        if(activityTypeList[i].activityType===val){
          setActivityParentType(activityTypeList[i].parentType);
          if(activityTypeList[i].parentType==='Event'){
            setStartDateTimeLabel("Event Session Start"); 
          }else{
            setStartDateTimeLabel("Due Date/Time"); 
          }
          break;
        }
      }
    }
  }

  function selectUser() {
      childRefUser.current.handleClickOpen();
  }

  function userDetail(obj) {
    setOwnerId(obj.autoId);
    setOwnerAlias(obj.fullName);
  }
   
  return (
    <>
      <Dialog  maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{(props.dataObj!=null && props.dataObj.autoId)?<>Edit</>:<>New</>} Activity</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >            
                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>                          
                     
                          <Grid item md={6} xs={12} >
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={activityType}
                                  label="Type"                                  
                                  onChange={event => handleActivityType(event.target.value)}
                                >
                                  {activityTypeList?activityTypeList.map((myRow,mykey)=>(
                                    <MenuItem key={'at'+mykey} value={myRow.activityType}>{myRow.activityType}</MenuItem>
                                  )):null}
                                </Select>
                              </FormControl>
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField label="Subject" onChange={event => setSubject(event.target.value)} value={subject} fullWidth variant="outlined" size="small" />
                          </Grid>
                          <Grid item md={12} xs={12} >
                              <TextField label="Remarks" onChange={event => setRemarks(event.target.value)} value={remarks} fullWidth variant="outlined" multiline size="small" />
                          </Grid>                
                                   
                          <Grid item md={6} xs={12} >
                              <LocalizationProvider dateAdapter={AdapterDayjs}  >
                                <Stack spacing={1} >
                                    <DateTimePicker                                                                             
                                      value={startDateTime}
                                      onChange={val => setStartDateTime(val)}
                                      renderInput={(params) => <TextField {...params} size="small" label={startDateTimeLabel} />}
                                      minDate={new Date()}
                                      inputFormat="DD-MM-YYYY hh:mm a"                                      
                                    />                                  
                                </Stack>
                              </LocalizationProvider>
                          </Grid>

                          {(activityParentType==='Event')?<>
                          <Grid item md={6} xs={12} >
                              <LocalizationProvider dateAdapter={AdapterDayjs}  >
                                <Stack spacing={1} >
                                    <DateTimePicker                                                                             
                                      value={endDateTime}
                                      onChange={val => setEndDateTime(val)}
                                      renderInput={(params) => <TextField {...params} size="small" label="Event Session End" />}
                                      minDate={new Date()}
                                      inputFormat="DD-MM-YYYY hh:mm a"                                      
                                    />                                  
                                </Stack>
                              </LocalizationProvider>
                          </Grid>                          
                          <Grid item md={6} xs={12} >
                              <TextField label="Location" onChange={event => setLocation(event.target.value)} value={location} fullWidth variant="outlined" size="small" />
                          </Grid>                          
                          <Grid item md={2} xs={12} >                                 
                              <FormControlLabel
                                control={
                                  <Checkbox checked={fullDay} onChange={event => setFullDay(event.target.checked)} />
                                }
                                label="Full Day Event"
                                size="small"
                              />  
                          </Grid>                         
                          <Grid item md={4} xs={12} >                                 
                              <FormControlLabel
                                control={
                                  <Checkbox checked={showMeAs} onChange={event => setShowMeAs(event.target.checked)} />
                                }
                                label="Show as Busy"
                                size="small"
                              />  
                          </Grid>                          
                          </>:null}

                          <Grid item md={6} xs={12} >
                              <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Priority</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={priority}
                                  label="Priority"                                  
                                  onChange={event => setPriority(event.target.value)}
                                >
                                  <MenuItem value={'Emergency'} >Emergency</MenuItem>
                                  <MenuItem value={'High'} >High</MenuItem>
                                  <MenuItem value={'Normal'} >Normal</MenuItem>
                                </Select>
                              </FormControl>
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <FormControl fullWidth size="small" >
                                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={status} 
                                  label="Status"
                                  onChange={event => setStatus(event.target.value)}
                                >
                                  <MenuItem value={'Open'}>Open</MenuItem>
                                  <MenuItem value={'Completed'}>Completed</MenuItem>
                                  <MenuItem value={'Cancelled'}>Cancelled</MenuItem>
                                </Select>
                              </FormControl>
                          </Grid>   
                          {status==='Cancelled'?                       
                          <Grid item md={6} xs={12} >                          
                            <TextField label="Activity Cancel Reason" onChange={event => setCancelReason(event.target.value)} value={cancelReason} fullWidth variant="outlined" size="small" />
                          </Grid>
                          :null}                          
                          {/* <Grid item md={6} xs={12} >
                              <input                             
                                className={classes.input}
                                style={{ display: 'none' }}
                                id="contentfile"
                                type="file" 
                                onChange={event => setContentFilePath(event.target.value)}
                              /> 
                              <label htmlFor="contentfile">
                            <Button component="span" style={{margin: 2}} size="small" variant="outlined" >
                              Browse File
                            </Button>   
                            {
                              (contentFilePath && contentFilePath!==null && contentUrl!=='null')?
                              <span style={{marginLeft:5}}>{contentFilePath}</span>
                              :(contentUrl && contentUrl!==null && contentUrl!=='null')?<><br/><a href={contentUrl} target="_blank" >{contentUrl}</a></>:null
                            }                         
                          </label>
                          </Grid> */}
                            
                            <Grid item md={6} xs={12} >
                            <Grid container spacing={2}>
                                <Grid item md={8} xs={8} >
                                    <TextField
                                      label="Agent"
                                      onChange={event => setOwnerAlias(event.target.value)}
                                      value={ownerAlias}
                                      fullWidth
                                      size='small'
                                      variant="outlined"
                                      disabled                                      
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectUser()}} />
                                          </InputAdornment>
                                        ),
                                        }}
                                  />
                                </Grid>
                                <Grid item md={4} xs={4} >
                                  <FormControl fullWidth size='small'  >
                                    <InputLabel id="demo-simple-select-label">Visibility</InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={accessType}
                                      label="Visibility"
                                      onChange={event => setAccessType(event.target.value)}
                                    >
                                      <MenuItem value={1} >Public</MenuItem>
                                      <MenuItem value={2} >Private</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>      

                            </Grid>   


                          <Grid item md={3} xs={12} >                                 
                              <FormControlLabel
                                control={
                                  <Checkbox checked={reminderTrigger} onChange={event => setReminderTrigger(event.target.checked)} />
                                }
                                label="Activate Reminder"
                                size="small"
                              />  
                          </Grid>
                          <Grid item md={3} xs={12} >                                 
                              <LocalizationProvider dateAdapter={AdapterDayjs}  >
                                <Stack spacing={1} >
                                    <DateTimePicker                                                                             
                                      value={reminderDateTime}
                                      onChange={val => setReminderDateTime(val)}
                                      renderInput={(params) => <TextField {...params} size="small" label="Reminder Date/Time" />}
                                      minDate={new Date()}
                                      inputFormat="DD-MM-YYYY hh:mm a"                                      
                                    />                                  
                                </Stack>
                              </LocalizationProvider>
                          </Grid>
                    </Grid>

                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {loadingBtn?
                            <LoadingButton
                              loading
                              loadingPosition="start"											
                              variant="outlined"
                              color="secondary"
                              id="waitloginbtnid" 
                              style={{width: 110, backgroundColor:'#008000',color:'#FFF',marginRight:10}}
                            >
                              Wait...
                            </LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }    
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} /> 
      <UserSelect userObj={props.userObj} fetchDetail={userDetail} fetch={true} ref={childRefUser} />
        
    </>
  );

});

export default CustomizedDialogs;